import { RadioOption } from 'Components/shared-components/radio-group/RadioGroup';
import { SelectOption } from 'Components/shared-components/select/Select';

export enum BallType {
  Premium = 'Premium',
  PremiumHard = 'PremiumHard',
  PremiumSoft = 'PremiumSoft',
  Medium = 'Medium',
  Hard = 'Hard',
  Soft = 'Soft',
  Floater = 'Floater',
  LimitedDistanceHard = 'LimitedDistanceHard',
  LimitedDistanceSoft = 'LimitedDistanceSoft',
  // Tennis = 'Tennis',
  // HammerMen = 'HammerMen',
  // ShotPutMe = 'ShotPutMe',
}
export const BALL_TYPE_TO_DISPLAY_NAME: Record<BallType, string> = {
  Premium: 'Premium',
  PremiumHard: 'Premium Hard',
  PremiumSoft: 'Premium Soft',
  Medium: 'Medium',
  Hard: 'Hard',
  Soft: 'Soft',
  Floater: 'Floater',
  LimitedDistanceHard: 'Limited Distance Hard',
  LimitedDistanceSoft: 'Limited Distance Soft',
  // Tennis = 'Tennis',
  // HammerMen = 'HammerMen',
  // ShotPutMe = 'ShotPutMe',
};

export enum DistanceUnit {
  Meters = 'Meters',
  Feet = 'Feet',
}

export enum TemperatureUnit {
  Celsius = 'Celsius',
  Fahrenheit = 'Fahrenheit',
}

export const DEFAULT_UNITS = {
  distance: DistanceUnit.Meters,
  temperature: TemperatureUnit.Celsius,
};

export const BALL_TYPE_OPTIONS: SelectOption<BallType>[] = [
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.Premium],
    value: BallType.Premium,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.PremiumHard],
    value: BallType.PremiumHard,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.PremiumSoft],
    value: BallType.PremiumSoft,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.LimitedDistanceHard],
    value: BallType.LimitedDistanceHard,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.LimitedDistanceSoft],
    value: BallType.LimitedDistanceSoft,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.Floater],
    value: BallType.Floater,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.Hard],
    value: BallType.Hard,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.Medium],
    value: BallType.Medium,
  },
  {
    label: BALL_TYPE_TO_DISPLAY_NAME[BallType.Soft],
    value: BallType.Soft,
  },
];

export const DISTANCE_UNIT_OPTIONS: RadioOption<DistanceUnit>[] = [
  {
    label: DistanceUnit.Meters,
    value: DistanceUnit.Meters,
  },
  {
    label: DistanceUnit.Feet,
    value: DistanceUnit.Feet,
  },
];

export const TEMPERATURE_UNIT_OPTIONS: RadioOption<TemperatureUnit>[] = [
  {
    label: TemperatureUnit.Celsius,
    value: TemperatureUnit.Celsius,
  },
  {
    label: TemperatureUnit.Fahrenheit,
    value: TemperatureUnit.Fahrenheit,
  },
];

export type NormalizationSettingsType = {
  /**
   * @description: in Meter
   */
  altitude: number;
  /**
   * @description: in Celsius
   */
  temperature: number;
  ballType: BallType;
  altitudeUnit: DistanceUnit;
  temperatureUnit: TemperatureUnit;
};

export const EMPTY_NORMALIZATION_SETTINGS: NormalizationSettingsType = {
  ballType: undefined,
  altitude: undefined,
  temperature: undefined,
  altitudeUnit: DEFAULT_UNITS.distance,
  temperatureUnit: DEFAULT_UNITS.temperature,
};

export const DEFAULT_NORMALIZATION_VALUES: NormalizationSettingsType = {
  altitude: 0,
  ballType: BallType.Premium,
  temperature: 25,
  // humidity: 0.75,
  altitudeUnit: DistanceUnit.Meters,
  temperatureUnit: TemperatureUnit.Celsius,
};
